import axios from "axios";

export const baseURLFront = process.env.REACT_APP_ENV === 'DEV' ? "http://localhost:3000" : "https://portal.bostoncityfc.com/"
export const baseURLAPI = process.env.REACT_APP_ENV === 'DEV' ? "https://apidev.bostoncityfc.com/" : "https://api.bostoncityfc.com/"

const api = axios.create({
    baseURL: baseURLAPI,
});

api.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (process.env.REACT_APP_ENV === 'DEV') console.log(response);
    return response;
}, function (error) {
    if (error.request.status === 403) {
        console.log(error.request);
        localStorage.clear();
        alert("A sua requisição foi rejeitada, iremos te redirecionar para a página inicial.");
        window.location.pathname = '/'; 
    }
    return Promise.reject(error);
});

async function setToken() {
    const token = localStorage.getItem("_token");
    if (token) {
        setUserType();
        api.defaults.headers.common['Authorization'] = `Token ${token}`;
        await api.get("check_token/")
            .then(function (response) {
                // handle success
                console.log(response);
                if (response.data.valido === false) {
                    localStorage.clear();
                    window.location.replace(baseURLFront);
                } else
                    console.log("Token válido");
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                if (error.response) console.log(error.response.data);
            });
    } else {
        localStorage.clear();
    }
}

export function checkTokenErrorResponse(response) {
    if (response.data && response.data.detail && response.data.detail === "Token inválido.") {
        localStorage.clear();
        window.location.replace(baseURLFront);
        alert("Acesso inválido, você será redirecionado para a página de login.");
    }
}

async function setTimezone() {
    const timezone = localStorage.getItem('_timezone');
    if (timezone)
        api.defaults.headers.common['TIMEZONE'] = timezone;
}

function setUserType() {
    const userType = localStorage.getItem('_userType');
    if (userType)
        api.defaults.headers.common['USERTYPE'] = userType;
}

function verifyIsAdminAndAcademy() {
    const academyInfos = localStorage.getItem("_academyInfos");
    const userType = localStorage.getItem("_userType");
    if(userType === 'acesso' && academyInfos){        
        if (api.defaults.headers.academia)
            delete api.defaults.headers.academia;
        api.defaults.headers.academia = JSON.parse(academyInfos).id;
    }
}

setUserType();
setToken();
setTimezone();
verifyIsAdminAndAcademy();

export default api;